export const ICONS_LOCATIONS = {
  START: 'start',
  END: 'end'
} as const;
